export const getUserCasesInOtherAreasWithCreatedBy = (userId, limit) => `
SELECT
    Id,
    CaseNumber,
    CreatedDate,
    Imagem_Status__c,
    Status,
    Subject,
    Owner.Name
FROM
    Case
WHERE
    CreatedBy.Id = '${userId}'
    AND OwnerId NOT IN ('${userId}', '00G41000002Q39NEAS', '00G41000001ohGLEAY')
    AND Status NOT IN ('Resolvido', 'Fechado', 'Closed as Duplicate', 'Closed', 'Merged')
${limit ? `LIMIT ${limit}` : ''}
`;
